import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Divider, Avatar, Dropdown, Menu } from 'antd';
import { connect } from 'react-redux';
import S from './header.module.less';

class LoginState extends Component {
  componentDidMount() {
    if (this.props.userInfo === null) {
      this.props.getUserInfo();
    };
  }

  componentDidUpdate(prevProps) {
    const { loginInfo } = this.props;
    const { loginInfo: prevLoginInfo } = prevProps;

    if (loginInfo.access_token !== prevLoginInfo.access_token) {
      this.props.getUserInfo();
    }
  }

  render() {
    const { userInfo } = this.props;

    return (
      <div>
        {
          userInfo === null
          ? <>
              <Button>
                <Link to="/auth/login">登录</Link>
              </Button>
              <Divider type='vertical' />
              <Button>
                <Link to="/auth/registered">注册</Link>
              </Button>
            </>
          : <Dropdown overlay={this.menuItem()}>
              <div>
                <Avatar size="large" src={userInfo.avatar} icon="user" />
                <span className={`ant-dropdown-link ${S.userName}`}>{userInfo.nickname}</span>
              </div>
            </Dropdown>
        }
      </div>
    )
  }

  menuItem = () => {
    const { logout } = this.props;

    return (
      <Menu>
        <Menu.Item key="1">
          <Link to="/personal/setting">个人中心设置</Link>
        </Menu.Item>
        <Menu.Item key="2" onClick={logout}>
          退出
        </Menu.Item>
      </Menu>
    )
  }
}

const mapState = ({ userInfo, loginInfo }) => ({
  userInfo,
  loginInfo,
});

const mapDispatch = ({ userInfo, loginInfo }) => ({
  getUserInfo: userInfo.getUserInfo,
  logout: loginInfo.logout,
});

export default connect(
  mapState,
  mapDispatch
)(LoginState);
